import { FC, useCallback, useEffect, useState } from "react";
import { AreaRepository, GeoLocationRepository } from "core/data/index";

import { IArea } from "core/interfaces/data/IAreaRequest";
import IAreaProps from "pages/Prenotazione/Form/Area/IAreaProps";

import { Input, Spin } from "antd";
import { CustomButton } from "core/interfaces/components/index";

import "./AreaNominatim.css";
import ReactGA from "react-ga4";
import { gaCategory, gaAction } from "types/HsbGaTypes";
import { setArea } from "core/redux/features/dataForm/dataFormSlice";
import i18n from "utils/i18n";
import { performAsyncFunction } from "utils/AsyncFunctionUtility";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import NavigationManager from "utils/NavigationManager";
import AddressRemoteSelect from "components/AddressRremoteSelect/AddressRemoteSelect";
import { Enhanced } from "utils/ReactUtils";
import { ReactI18NextChild } from "react-i18next";
import { FaCheckCircle } from "react-icons/fa";

const AreaNominatim: FC<IAreaProps> = ({ t, sessionInfo, dispatch, dataForm ,handleError}) => {
	const NumericValueRegEx = /^[0-9\b]+$/;

	const { MoveStep } = NavigationManager(sessionInfo);


	const [areas, setAreas] = useState<IArea[] | undefined>(undefined);
	const [cap, setCap] = useState<string | undefined>(dataForm.area?.LuogoErogazione?.CAP);
	const [capLoading,setCapLoading]=useState(false)
	const [idLocation, setIdLoacation] = useState<string | undefined>("");

	const SetArea = (area: IArea) => {
		dispatch(setArea(area));
		MoveStep("next");
	};


	// lo useEffect "corrisponde" al costruttore se fosse un componente a classe
	// quindi ogni volta che avviene un cambiamento sullo stato richiama quello che è all'interno
	useEffect(() => {
		performAsyncFunction(async () => {
		if(cap){
			//setto che il loading a true per mostrare il component di 
			const data = await AreaRepository.getArea({
				CAP: cap,
				culture: i18n.language,
				IdSessione: sessionInfo.sessione!.idSessione,
				step: sessionInfo.step as number,
			});
			if (data?.length === 1) {
				setSelectedArea(data[0])
			}

			if (!data || data?.length === 0) {
				setAreas([])
			}
			setCapLoading(false)
			setAreas(data);
		
		}
		else setCapLoading(false)
		}, handleError);
	}, [cap, sessionInfo.step, dataForm.area, handleError, sessionInfo.sessione]);

	// quando sceglie la equipe chiamo questo metodo
	const OnSubmit = async () => {
		if(selectedArea!==undefined){
			const IdEquipe=selectedArea.IdEquipe
			const CodGruppo=selectedArea.CodGruppo
			performAsyncFunction(async () => {
				if (areas) {
					// cerco l'equipe che corrisponde all'id e al codgruppo
					let area = areas.filter((area) => {
						return area.IdEquipe === IdEquipe && area.CodGruppo === CodGruppo;
					})[0];
					if (idLocation) {
						const foundLocations = await GeoLocationRepository.getGeoLocationById({
							IdSessione: sessionInfo.sessione!.idSessione,
							culture: i18n.language,
							Location: idLocation,
						});
						if (foundLocations) {
							area.LuogoErogazione = {
								CAP: foundLocations.Address.PostCode,
								Comune: foundLocations.Address.Village ?? foundLocations.Address.County,
								Provincia: foundLocations.Address.County,
								Via: foundLocations.Address.Road,
								Civico: foundLocations.Address.HouseNumber,
								CodIstat: foundLocations.Address.CodIstat,
								CAPMultipli: undefined,
							};
						}
					} else if (cap !== undefined) {
						area.LuogoErogazione = {
							CAP: cap,
							Comune: "",
							CodIstat: undefined,
							Civico: undefined,
							Provincia: "",
							CAPMultipli: undefined,
							Via: undefined,
						};
					}
					// e lo setto nei dati da salvare
					SetArea(area);
				}
			}, handleError);
		}
	};
	

	const onCapChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		var val = e.currentTarget.value;
		setIdLoacation(undefined);
		if (val.trim() !== "" && NumericValueRegEx.test(val) && val.length === 5) {
			setCapLoading(true)
			setCap(val.toString());
			ReactGA.event({ category: gaCategory.search, action: gaAction.capSearch });
		} else {
			if (val.length >= 5) {
				setCap(val.substring(0, 5));
			} else {
				setCapLoading(false)
				setCap(undefined);
				setAreas(undefined)
			}
		}
	};

	const addresRemoteSelectValueChanged = (newValue: any) => {
		setCap(newValue?.split("|")[1]);
		setIdLoacation(newValue?.split("|")[0]);
	};

	const [selectionRows,setSelectionRows]=useState<ReactI18NextChild[]>([])
	const [selectedArea,setSelectedArea]=useState<IArea|undefined>()
	
	
	
	
	const buildSelectionRows=useCallback(()=>{
		const buildList=[]
		if(areas!==undefined){
			for(let [i,a] of areas.entries()){
				let text=`${a.Descrzione} ${
					areas.some((element: IArea) => {return element.Descrzione === a.Descrzione && element.CodGruppo !== a.CodGruppo;})?
						"(" + a.CodGruppo + ")"
						:
						""
					}`
				let selected=a.Descrzione===selectedArea?.Descrzione
				buildList.push(<div key={"row-"+i} aria-label={`${selected?t("area.selezionata"):t("area.non-selezionata")}: ${text}`} className={`selection-row ${selected?"selected":""}`}
					role="button" tabIndex={0}
					onClick={() => setSelectedArea(a)}
					onKeyDown={(event) => {
						if (event.key === "Enter") {
							setSelectedArea(a);
						}
					}}
				>
					<div className="spacer"></div>
					<FaCheckCircle className={`icon ${selected ? "" : "hidden"}`} />
					<div className="grow-spacer"></div>
					<span className="text">{text}</span>
					<div className="grow-spacer"></div>
					<div className="spacer"></div>
				</div>)
			}
		}
		setSelectionRows(buildList)
	},[areas, selectedArea?.Descrzione, t])

	
	
	useEffect(()=>{
		buildSelectionRows()
	},[areas, buildSelectionRows])
	useEffect(()=>{
		buildSelectionRows()
	},[buildSelectionRows, selectedArea])

	return (
		<div id="area">
			<div className="title item ">
				<span>{t("area.title")}</span>
			</div>
			<div className="text item">
				<span>{t("area.domicilio")}</span>
			</div>
			<div className="cap-find">
				<AddressRemoteSelect
					mode="multiple"
					size="large"
					allowClear={false}
					dropdownMatchSelectWidth={false}
					placeholder={t("area.domicilioPlaceHolder")}
					className="domicilioSelector"
					onValueChanged={addresRemoteSelectValueChanged}
					addressBookTitle={t("area.addressBookTitle")}
					idLocation={idLocation}
				/>

				<div className="input-cap">
					<Input
						size="large"
						placeholder={t("area.cap.placeholder")}
						type="number"
						// onKeyDownCapture={onCapInput}
						maxLength={5}
						value={cap?.valueOf()}
						onChange={onCapChange}
					/>
				</div>
			</div>
			
				
			<div className="placeholder-spacer">
				{areas && areas.length>0 &&
					<div className="selection-rows-container">
						{selectionRows}
					</div>
				}
				
				{capLoading && <Spin spinning={true}></Spin>}

				{areas && areas.length===0 && <span className="no-area">{t("area.notFound")}</span>}
			</div>
			<div className="button-box item">
				<CustomButton text={t("backButton")} OnClick={() => MoveStep("prev")} buttonType={CustomButtonType.negative} />
				<CustomButton text={t("prestazione.button")} OnClickAsync={OnSubmit} buttonType={CustomButtonType.positive} enabled={selectedArea!==undefined} />
			</div>


		</div>
	);
};

export default Enhanced(AreaNominatim, { componentNamespace: "AreaNominatim" });
